import React from "react";
import useExportTable from "./useExportTable";
import { Button } from "react-bootstrap";
import { toast } from "wc-toast";

const ExportIcon = ({ id, data, title }) => {
  const { exportToCSV, exportToExcel, exportToExcelMacro } = useExportTable(id);
  return (
    <div style={{display:"flex",justifyContent:"end"}}>
      {" "}
      <Button
        className="theme_dark_btn"
        style={{ marginRight: "5px" }}
        onClick={() => {
          if (data?.length > 0) {
            exportToExcelMacro(title,  ["Transaction File"]);
          } else {
            toast.error("No Data Found!");
          }
        }}
      >
        Export As XLSM
      </Button>{" "}
      <Button
        className="theme_dark_btn"
        style={{ marginRight: "5px" }}
        onClick={() => {
          if (data?.length > 0) {
            exportToCSV(title, ["Transaction File"]);
          } else {
            toast.error("No Data Found!");
          }
        }}
      >
        Export As CSV
      </Button>{" "}
      <Button
        className="theme_dark_btn"
        style={{ marginRight: "10px" }}
        onClick={() => {
          if (data?.length > 0) {
            exportToExcel(title,  ["Transaction File"]);
          } else {
            toast.error("No Data Found!");
          }
        }}
      >
        Export As Excel
      </Button>
    </div>
  );
};

export default ExportIcon;
